<div class="friends-member wpee-block">
  <div class="wpee-block-header">
    <h4 class="wpee-block-title">Friends</h4>
  </div>
  <div class="wpee-block-footer">
    <a class="edit-profile-link" *ngIf="!loader2" (click)="user_friends()">View All Friends</a>
    <div [ngClass]="{ 'shine': loader2 }">

    </div>
  </div>
  <div class="profile-friends-member-inner wpee-block-content">
    <ul class="friends-section profile-friends-list" *ngIf="!loader">
      <li class="" *ngFor="let friend of friends | slice:0:6">
        <figure class="img-holder">
          <!-- <a title="Shawn" [routerLink]="['/member-profile',friend.username,'Profile']"> -->
          <a [routerLink]="getProfileLink(friend?.username)">
            <div style="background: url('{{friend.profilePicPath}}') no-repeat top -20px center/cover"
              class="profile-friend-cover-thumb"></div>
          </a>
          <div class="wpee-user-status wpee-online"></div>
        </figure>
        <span class="user-name-show">
          <a [routerLink]="getProfileLink(friend?.username)">
            <!-- <a [routerLink]="['/member-profile',friend.username,'Profile']"> -->
            {{friend.username}}</a>
          <span class="count-friends">Friends ({{friend.friendCount}})</span>
        </span>
      </li>
    </ul>
    <div [ngClass]="{ 'shine': loader }">
    </div>
    <span class="dsp_span_pointer" *ngIf="friends?.length == 0 && !showErrorMessage && !loader">No Friends Added</span>
    <span class="dsp_span_pointer" *ngIf="friends?.length == 0 && showErrorMessage && !loader">Friend list is
      private.</span>
  </div>
</div>